import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19c28a85")

_pushScopeId("data-v-19c28a85")
const _hoisted_1 = { class: "kn-material-input-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('managers.scheduler.documentsTree')), 1),
    _createVNode(_component_Tree, {
      class: "documents-tree p-mt-2",
      value: _ctx.nodes,
      expandedKeys: _ctx.expandedKeys,
      onNodeExpand: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
      onNodeCollapse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
    }, {
      default: _withId((slotProps) => [
        _createVNode("i", {
          class: slotProps.node.customIcon
        }, null, 2),
        _createVNode(_component_Checkbox, {
          class: "p-ml-2",
          name: "folders",
          modelValue: _ctx.selectedFolders,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFolders = $event)),
          value: slotProps.node.id,
          onChange: _ctx.emitSelectedFolders
        }, null, 8, ["modelValue", "value", "onChange"]),
        _createVNode("b", null, _toDisplayString(slotProps.node.label), 1)
      ]),
      _: 1
    }, 8, ["value", "expandedKeys"])
  ]))
})